import type {PrincipledBsdfNode} from "#material/cycles/types"

export const cyclesDistribution = (distribution?: "GGX" | "MULTI_GGX"): PrincipledBsdfNode["parameters"]["distribution"] => {
    if (!distribution) {
        return undefined
    }
    switch (distribution) {
        case "GGX":
            return "ggx"
        case "MULTI_GGX":
            return "multi_ggx"
    }
}

export const cyclesSurfaceMethod = (surfaceMethod?: "BURLEY" | "RANDOM_WALK"): PrincipledBsdfNode["parameters"]["subsurface_method"] => {
    if (!surfaceMethod) {
        return undefined
    }
    switch (surfaceMethod) {
        case "BURLEY":
            return "burley"
        case "RANDOM_WALK":
            return "random_walk"
    }
}
